"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ContentLine_1 = require("../../contentLine/ContentLine");
var Price_1 = require("../../../../../common/components/prices/price/Price");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var PriceDisplayType_1 = require("../../../../../../../../common/enum/PriceDisplayType");
var ShowIfTranslationExists_1 = require("../../../../../../common/components/ShowIfTranslationExists");
var GridItemPrice = function (_a) {
    var price = _a.price, currency = _a.currency, isMultiCurrency = _a.isMultiCurrency, dataTest = _a.dataTest, label = _a.label, className = _a.className, taxLabel = _a.taxLabel;
    var _b, _c, _d;
    var translationKey = 'carDetails.label.rdp';
    return (<>
      <ContentLine_1.default dataTest={dataTest} mainContent={<core_1.Typography variant="subtitle1" component="span" className={(_b = className) === null || _b === void 0 ? void 0 : _b.label}>
            <Translation_1.default className={(_c = className) === null || _c === void 0 ? void 0 : _c.label} id={label}/>
          </core_1.Typography>} secondaryContent={<>
            <Price_1.default className={(_d = className) === null || _d === void 0 ? void 0 : _d.price} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} price={price} currency={currency} dataTest={dataTest} taxLabel={taxLabel}/>
            {!isMultiCurrency && (<ShowIfTranslationExists_1.default translationKey={translationKey}>
                <core_1.Typography variant="subtitle1" component="span">
                  <Translation_1.default id={translationKey}/>
                </core_1.Typography>
              </ShowIfTranslationExists_1.default>)}
          </>}/>
    </>);
};
exports.default = GridItemPrice;
